import { useCallback, useEffect, useMemo, useState } from 'react';
import {
  getReadinessStrings,
  READINESS_LOCALE_STORAGE_KEY,
  ReadinessLocale,
  resolveReadinessLocale,
} from '../i18n/readinessLocale';

export const useReadinessLocale = () => {
  const [locale, setLocaleState] = useState<ReadinessLocale>(() => {
    if (typeof window === 'undefined') {
      return 'en';
    }
    return resolveReadinessLocale(window.localStorage.getItem(READINESS_LOCALE_STORAGE_KEY));
  });

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    window.localStorage.setItem(READINESS_LOCALE_STORAGE_KEY, locale);
  }, [locale]);

  const setLocale = useCallback((next: ReadinessLocale) => {
    setLocaleState(resolveReadinessLocale(next));
  }, []);

  const strings = useMemo(() => getReadinessStrings(locale), [locale]);

  return {
    locale,
    setLocale,
    strings,
  };
};

export default useReadinessLocale;
